import React from 'react';

const Banner = () => {
  return (
    <section id="home" className="relative w-full">
      {/* Main Banner Image */}
      <div className="relative w-full">
        <img
          src="/banner.png"
          alt="Paridhi Guest House Banner"
          className="w-full h-auto md:h-[90vh] lg:h-screen object-cover object-center"
          onError={(e) => {
            e.target.src = '/banner1.png';
            e.onerror = null;
          }}
        />
        
        {/* Light Gradient Overlay - Only if needed for text readability */}
        {/* <div className="absolute inset-0 bg-gradient-to-r from-black/20 via-transparent to-transparent"></div> */}
      </div>
    </section>
  );
};

export default Banner;